import random from "utils/random";

function randomiseIssueLevel(document, issue) {
  const r = random(document.id + issue.id);
  return r < 0.25 ? "high" : r < 0.5 ? "moderate" : "low";
}

export default randomiseIssueLevel;
